import { useEffect, useMemo, useState } from 'react'
import { fetchBoxTruckLeadSources } from '../services/boxTruckLoadsApi'
import { BOX_TRUCK_DEFAULT_LEAD_SOURCES } from '../utils/format'

/**
 * The lead-source options for the Add-driver modal and the My Drivers "Source" filter: the built-in defaults
 * (Numeo/Facebook/Indeed) plus the team's custom sources, fetched once. On failure the defaults still show.
 * `setCustom` lets a page fold in a just-added source (the add endpoint returns the updated custom list).
 */
export function useBoxTruckLeadSources(enabled = true): { sources: string[]; setCustom: (custom: string[]) => void } {
    const [custom, setCustom] = useState<string[]>([])
    useEffect(() => {
        if (!enabled) return
        fetchBoxTruckLeadSources()
            .then(setCustom)
            .catch(() => setCustom([]))
    }, [enabled])
    const sources = useMemo(() => [...new Set([...BOX_TRUCK_DEFAULT_LEAD_SOURCES, ...custom])], [custom])
    return { sources, setCustom }
}
